module.exports = __webpack_public_path__ + "img/sean.003d34fa.png";